<template>
  <navbar>
    <my-button @click="$router.push('/auth/log_in')">log in</my-button>
  </navbar>

  <div class="bar">
    <!-- <div>Bar</div> -->
    <my-button @click="$router.push('/bar')">Bar</my-button>
    <my-button @click="$router.push('/profile')">Profile</my-button>
    <my-button @click="$router.push('/top')">Top</my-button>
  </div>
</template>


<script>
import Navbar from '@/components/Navbar.vue';

export default {
  components: {
    Navbar
  },
  methods: {
    async isauth() {
      let res = await fetch('/api/auth/isauth', {
        method: "POST",
        headers: {"content-type": "application/json"},
      });
      if (res.status === 200) {
        let data = await res.json();
        // console.log(data['auth']);
        if (!data['auth']) {
          this.$router.push('/auth/log_in');
        }
      }
    }
  },
  mounted() {
    this.isauth();
  }
}
</script>


<style scoped>
.bar {
  margin: auto;
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  /* justify-self: center; */
  /* align-items: center; */
  /* width: 100%; */
  width: max-content;
}
</style>
